import React, { forwardRef } from 'react';
import DatePicker from 'react-datepicker';
// import PropTypes from 'prop-types';

import 'react-datepicker/dist/react-datepicker.css';
import '../Input.scss';
import './DateInput.scss';

interface CustomProps {
  default?: string | Date;
  placeholder?: string;
  onChange: (value: Date) => void;
  gap?: 'no' | 'sm' | 'md' | 'lg';
  name?: string;
  label?: string;
  error?: string;
  minDate?: Date;
  maxDate?: Date;
  filterDate?: (date: Date) => boolean;
  disabled?: boolean;
  popperPlacement?: string;
}

interface CustomState {
  value?: Date;
}

class DateInput extends React.Component<CustomProps, CustomState> {
  static defaultProps: Partial<CustomProps> = {
    gap: 'md',
    name: '',
    label: '',
    error: '',
    placeholder: '',
    popperPlacement: 'auto',
  };
  constructor(props: CustomProps) {
    super(props);
    this.state = {
      value: this.props.default ? new Date(this.props.default) : undefined,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps: CustomProps) {
    if (this.props.default && prevProps.default !== this.props.default) {
      this.updateDefault();
    }
  }

  updateDefault() {
    this.setState({ value: new Date(this.props.default || '') });
  }

  handleChange(date: Date) {
    this.setState({
      value: date,
    });
    this.props.onChange(date);
  }

  render() {
    const {
      name,
      label,
      placeholder,
      gap,
      error,
      minDate,
      maxDate,
      filterDate,
      disabled,
      popperPlacement,
    } = this.props;
    const inputIdCandidate = name || label || placeholder || '';
    const inputId = inputIdCandidate.toLowerCase().split(' ').join('-');
    return (
      <div className={`textField textField--margin-${gap}`}>
        {label && (
          <label
            htmlFor={inputId}
            className="textField__label textField__label--full"
          >
            {label}
          </label>
        )}

        <DatePicker
          id={inputId}
          selected={this.state.value}
          onChange={this.handleChange}
          minDate={minDate}
          maxDate={maxDate}
          placeholderText={placeholder}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          dateFormat="dd/MM/yyyy"
          customInput={<CustomDateInput />}
          filterDate={filterDate}
          disabled={disabled}
        />
        {/* <i className="icon-calendar" /> */}
        {error && <span className="textField__validation">{error}</span>}
      </div>
    );
  }
}

export default DateInput;

// using forwardRef for this issue:
// https://github.com/Hacker0x01/react-datepicker/issues/862
const CustomDateInput = forwardRef((props, ref) => {
  const { id, placeholder, value, onClick }: { [key: string]: any } = props;
  return (
    <div>
      <input
        id={id}
        className="textField__input textField__input--icon"
        placeholder={placeholder}
        onClick={onClick}
        value={value}
        readOnly
      />
      <i className="icon-calendar" />
    </div>
  );
});

// CustomDateInput.propTypes = {
//   id: PropTypes.string.is,
//   placeholder: PropTypes.string,
//   value: PropTypes.string,
//   onClick: PropTypes.func,
// };

// CustomDateInput.defaultProps = {
//   placeholder: '',
//   value: null,
//   id: '',
//   onClick: () => {},
// };
